module.exports = __webpack_public_path__ + "svg/flags/Bolivia, Plurinational State of.svg";